import { Select } from 'antd';
import { useMemo } from 'react';
import styled from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import Typo from '@/components/Typography/Typo';
import { CHART_TERM_TYPE, CHART_TERM_UNIT } from '@/entities/chart/model/constants';
import useChartStateAction from '@/features/(charts)/chart-controller/hooks/use-chart-state-action/useChartStateAction';
import chartUtils from '@/features/(charts)/chart-renderer/lib/chart-utils';
import {
  ChartPeriodRelativeMap,
  ChartTermUnitMap,
} from '@/features/(charts)/chart-renderer/model/chart-maps';

type Props = {
  chartInfo: ChartContextProps;
};

const ChartTermSelect = (props: Props) => {
  const { chartInfo } = props;
  const { state } = chartInfo;
  if (state.target.term.type !== CHART_TERM_TYPE.PERIODIC)
    throw new Error('Invalid term type');

  const { onTermUnitChange, onTermRelativeChange, onTermValueChange } =
    useChartStateAction(chartInfo);

  const message = useMemo(() => {
    if (state.target.term.type === CHART_TERM_TYPE.FIXED) return '';
    switch (state.target.term.unit) {
      case CHART_TERM_UNIT.DAY:
        return 'today';
      case CHART_TERM_UNIT.WEEK:
        return 'this week';
      case CHART_TERM_UNIT.MONTH:
        return 'this month';
      case CHART_TERM_UNIT.QUARTER:
        return 'this quarter';
    }
  }, [state.target.term]);

  const readableDateRange = chartUtils.getReadableDateRangeByTerm(
    state.target.term,
  );

  return (
    <VFlex g={12}>
      <Flex g={8} a="center">
        <Typo type="label3">Last</Typo>
        <StyledInput
          value={state.target.term.value}
          onChange={onTermValueChange}
        />
        <Select
          style={{ width: 120 }}
          value={state.target.term.unit}
          onChange={onTermUnitChange}
          options={ChartTermUnitMap.toArray()}
        />
      </Flex>
      <Flex g={8} a="center">
        <Select
          style={{ width: 120 }}
          value={state.target.term.relative}
          onChange={onTermRelativeChange}
          options={ChartPeriodRelativeMap.toArray()}
        />
        <Typo type="label3">{message}</Typo>
      </Flex>
      <Typo type="label3" className="text-gray-600">
        {readableDateRange}
      </Typo>
    </VFlex>
  );
};



const StyledInput = styled.input`
  width: 60px;
  height: 32px;
  border: 1px solid ${(props) => props.theme.colors.gray400};
  border-radius: 4px;
  padding: 4px;
  padding-left: 12px;
  background-color: ${(props) => props.theme.colors.gray100};
  color: ${(props) => props.theme.colors.gray800};
`;

export default ChartTermSelect;
